import { Pleb } from '../models/Pleb';
import { FakeData } from './FakeData';
import { Repository } from './Repository';

export class CurrentUserRepository extends Repository {
  async getProfile(): Promise<Pleb> {
    const path = 'v1/users/me';

    try {
      if(Repository.offlineMode) {
        return FakeData.getPleb();
      }
      const response = await Repository.client.get(path);
      return Pleb.currentUserFromJson(response.data.data);
    } catch (err) {
      throw err;
    }
  }
}

// Create a singleton instance
export const currentUserRepository = new CurrentUserRepository();
